var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c360-edit-campaign-dialog',{attrs:{"open":_vm.value,"token":_vm.token,"campaign-id":_vm.campaign.id},on:{"closed":function($event){return _vm.$emit('change', false)},"edit-campaign-errors":function($event){return _vm.onError($event.detail)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }